<!--  -->
<template>
  <div>
    <van-popup v-model="showPop">
      <div class="menber-dialog">
        <img class="close" @click="showPop=false" src="@/assets/img/arkHome/member-close.png" alt="" />
        <img class="title" src="@/assets/img/arkHome/member-title.png" alt="" />
        <p>立享专属会员特权，快去开通吧~</p>
        <img class="crown" src="@/assets/img/arkHome/member-crown.png" alt="" />
        <img class="btn" @click="buyMember" src="@/assets/img/arkHome/member-btn.png" alt="" />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showPop: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    buyMember() {
      localStorage.setItem('miniBeforePageName', '9');
      this.$router.push({ path: '/personalCenter/member?activeTab=30' });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
::v-deep .van-popup {
  border-radius: 7px;
}
.menber-dialog {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 525px;
  height: 596px;
  background: linear-gradient(180deg, #fff 0%, #fae7ca 100%);
  border: 2px solid;
  border-radius: 14px;
  border-image: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(250, 231, 202, 1)) 2 2;
  .close {
    position: absolute;
    top: 36px;
    right: 36px;
    width: 29px;
    height: 29px;
  }
  .title {
    width: 263px;
    height: 40px;
    margin: 65px 0 22px 0;
  }
  > p {
    width: 393px;
    height: 54px;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    line-height: 54px;
    text-align: center;
    background: #3e3a3f;
    border-radius: 7px;
  }
  .crown {
    width: 304px;
    height: 226px;
  }
  .btn {
    width: 417px;
    height: 80px;
  }
}
</style>
